module.exports = __webpack_public_path__ + "i18n/ru.136cba2284e35016066ab87550f3fe8c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1293
// module chunks = 60